import { useEffect } from "react";
import LeaderboardTables from "./LeaderboardTables";
import LeaderboardsProvider from "./providers/LeaderboardsProvider";
import ShowLeaderboardCreateButton from "./components/ShowLeaderboardCreateButton";
import LeaderboardControlsProvider from "./providers/LeaderboardControlsProvider";
import { useTranslation } from "react-i18next";
import logEvent from "utils/logEvent";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import { Page, PageHeaderActions, PageTitle } from "components/Layout";
import MuiThemeProvider from "components/MuiThemeProvider";
import LeaderboardsInfoCardAdornment from "./components/LeaderboardsInfoCardAdornment";

interface LeaderboardsProps {}

function Leaderboards(props: LeaderboardsProps) {
  const { t } = useTranslation();

  useEffect(() => {
    logEvent("LEADERBOARDS_VIEW_ALL");
  }, []);

  return (
    <ThemeProvider2024>
      <LeaderboardsProvider>
        <LeaderboardControlsProvider>
          <Page
            header={
              <>
                <PageTitle endAdornment={<LeaderboardsInfoCardAdornment />}>{t("leaderboard.page_title")}</PageTitle>
                <PageHeaderActions>
                  <ShowLeaderboardCreateButton />
                </PageHeaderActions>
              </>
            }
          >
            <MuiThemeProvider>
              <LeaderboardTables />
            </MuiThemeProvider>
          </Page>
        </LeaderboardControlsProvider>
      </LeaderboardsProvider>
    </ThemeProvider2024>
  );
}

export default Leaderboards;
